<!-- 由 suu 创建于 2021-08-11 星期三 -->
<template>
  <div
    class="WeDateTab"
    :class="{
      'WeDateTab-detail': tfrom == 'detail'
    }"
  >
    <div
      class="dt-row"
      @touchmove.stop="handleChildScroll"
      @scroll.stop="handleChildScroll"
    >
      <div
        class="dt-col"
        :style="{ minWidth: colWidth + 'vw' }"
        @click="onTab(item)"
        :class="{
          'dt-col-ac': curDate == item.a_day,
          'dt-col-ac-zqj': curDate == item.a_day && $parent.isZqj,
          'dt-col-ac-grade-qy-normal':
            tfrom == 'subscribe' && user.user_grade > 3,
          'dt-col-ac-grade-qy': isGradeQy(index)
        }"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="dt-week">{{ weekText[index] || item.week }}</div>
        <div class="dt-day">{{ item.day }}</div>
        <div class="day-recommend" v-if="isSpringDayText(item)">{{
          isSpringDayText(item)
        }}</div>
        <img
          class="grade-qy-icon"
          v-else-if="isGradeQy(index)"
          :src="`https://cdnvue.gymcity.com.cn/uploads/mgs-icon-zs-v${user.user_grade}`"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeDateTab',

  components: {},

  props: {
    // 引入页面
    tfrom: {
      type: String,
      require: false
    },
    // 日期
    dayInfo: {
      type: Array,
      require: true
    },
    // 初始激活日期
    activedDate: {
      type: Object
    },
    // 单列日期最小宽度
    colWidth: {
      type: [String, Number],
      default: 12
    },
    // 最外层样式
    tabStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      curDate: '', // 当前选择日期
      weekText: ['今天', '明天']
    }
  },

  computed: {
    user() {
      return this.$store.state.user.user
    },
    list() {
      let arr = []
      this.dayInfo.map((v) => {
        const day = v.a_day.slice(-2)
        const week = '周' + v.week
        arr.push({
          a_day: v.a_day,
          day,
          week
        })
      })
      return arr
    }
  },

  watch: {
    activedDate(newVal, oldVal) {
      this.curDate = (newVal && newVal.a_day) || this.dayInfo[0].a_day
    },
    list: {
      handler(newVal) {
        this.initScroll(newVal)
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.curDate =
      (this.activedDate && this.activedDate.a_day) || this.dayInfo[0].a_day
  },

  mounted() {},

  destroyed() {},

  methods: {
    isGradeQy(index) {
      return this.tfrom == 'subscribe' && index > 6 && this.user.user_grade > 3
    },
    initScroll(list) {
      this.$nextTick(() => {
        if (
          this.$route.query.day &&
          new Date() <= new Date(this.$route.query.day.replace(/-/g, '/')) &&
          list.length > 0 &&
          !sessionStorage[`loadQeuryDayDateTab_${this.tfrom}`]
        ) {
          sessionStorage[`loadQeuryDayDateTab_${this.tfrom}`] = 1
          // 找到匹配日期的索引
          const targetIndex = list.findIndex(
            (item) => item.a_day === this.$route.query.day
          )
          const scrollNum = targetIndex - (this.tfrom == 'detail' ? 6 : 7)
          // 超过7（默认能见个数 detail里是6）才移动
          if (scrollNum >= 0) {
            const scroll = document.querySelector('.WeDateTab')
            const row = document.querySelector('.dt-row')
            if (scroll) {
              // 计算需要滚动的距离
              const itemWidth = row.children[targetIndex].offsetWidth
              // 使用scrollIntoView Y轴也会移动一点
              // itemWidth.scrollIntoView({ behavior: 'smooth' })
              const scrollLeft = itemWidth * scrollNum + itemWidth / 2
              // 使用 scrollTo 方法平滑滚动到目标位置
              scroll.scrollTo({
                left: scrollLeft,
                behavior: 'smooth'
              })
            }
          }
        }
      })
    },
    handleChildScroll(event) {
      // console.log('子元素滚动')
    },
    /**
     * 判断闭馆通知角标显示
     */
    isSpringDayText(item) {
      const config = this.$store.state.closeNotice
      const now = new Date().getTime()
      if (
        now >= new Date(config.endDate).getTime() ||
        !config.regionIds.includes(Number(this.user.current_city.region_id))
      ) {
        return false
      }
      if (
        new Date(item.a_day.replace(/-/g, '/')).getTime() >=
          new Date(config.startDate).getTime() &&
        new Date(item.a_day.replace(/-/g, '/')).getTime() <
          new Date(config.endDate).getTime()
      ) {
        return config.closedText
      }
      if (
        new Date(item.a_day.replace(/-/g, '/')).getTime() >=
        new Date(config.endDate).getTime()
      ) {
        return config.openedText
      }
    },
    /**
     * 点击tab
     */
    onTab(item) {
      if (this.curDate !== item.a_day) {
        this.curDate = item.a_day
        this.$emit('dateChange', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.WeDateTab {
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  /* 允许横向和垂直滑动 */
  // touch-action: pan-x pan-y;
  padding: 0 4.1vw;
  padding-bottom: 2.1vw;
  z-index: 9;
  .dt-row {
    min-width: 100%;
    width: fit-content;
    height: 100%;
    box-sizing: border-box;
    @include flex-r;
    flex-wrap: nowrap;
    justify-content: space-around;
    .dt-col {
      flex: 1;
      height: 100%;
      box-sizing: border-box;
      @include flex-c;
      justify-content: center;
      font-size: 3.5vw;
      font-weight: 600;
      color: #000000;
      padding-bottom: 2vw;
      padding-top: 2.1vw;
      position: relative;
      .dt-day {
        margin-top: 1.6vw;
        font-weight: normal;
        color: rgba(0, 0, 0, 0.5);
      }
      .day-recommend {
        color: #dc0050;
        font-size: vw(9);
        font-weight: 600;
        position: absolute;
        top: 0;
        right: vw(1);
        // left: 50%;
        // transform: translateX(-50%);
      }
    }
    .dt-col-ac {
      background-color: transparent;
      color: $weRed;
      position: relative;
      .dt-day {
        color: $weRed;
      }
    }
    .dt-col-ac::after {
      content: '';
      width: 6.4vw;
      height: 0.8vw;
      background-color: #f04646;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: vw(0);
    }
    .dt-col-ac-zqj {
      color: #f9a225;
      .dt-day {
        color: #f9a225;
      }
    }
    .dt-col-ac-zqj::after {
      background-color: #f9a225;
    }
    // 登记大于3
    .dt-col-ac-grade-qy-normal {
      padding-top: 3.1vw;
    }
    // 等级大于3 并且是特权日期
    .dt-col-ac-grade-qy {
      background-color: #fff7eb;
      position: relative;
      .grade-qy-icon {
        width: vw(36);
        position: absolute;
        top: vw(1);
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
.spring-tab {
  padding-top: 4vw;
}
.WeDateTab::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  width: 0 !important;
}
.WeDateTab-detail {
  padding: vw(18) vw(9);
  .dt-row {
    min-width: 100%;
    width: fit-content;
    height: 100%;
    box-sizing: border-box;
    @include flex-r;
    flex-wrap: nowrap;
    justify-content: space-around;
    .dt-col {
      min-width: vw(54) !important;
      flex: 1;
      height: 100%;
      box-sizing: border-box;
      @include flex-c;
      justify-content: center;
      font-size: vw(15);
      font-weight: 300;
      color: rgba($color: #050b27, $alpha: 0.8);
      position: relative;
      padding-bottom: 0;
      .dt-week {
        line-height: vw(21);
      }
      .dt-day {
        margin-top: vw(7);
        width: vw(32);
        height: vw(32);
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .day-recommend {
        color: #dc0050;
        font-size: vw(9);
        font-weight: 600;
        position: absolute;
        top: vw(-12);
        right: vw(-4);
      }
    }
    .dt-col-ac {
      color: #050b27;
      font-weight: 600;
      .dt-day {
        border-radius: 99px;
        border: 1px solid #050b27;
        color: #050b27;
        font-weight: 600;
      }
    }
    .dt-col-ac::after {
      display: none;
    }
    .dt-col-ac-zqj {
      background-color: transparent;
      position: relative;
      color: #f9a225;
      .dt-day {
        color: #f9a225;
      }
    }
    .dt-col-ac-zqj::after {
      content: '';
      width: 6.4vw;
      height: 0.8vw;
      // background-color: #f04646;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: vw(0);
      background-color: #f9a225;
    }
  }
}
</style>
